<template>
	<div class="__report-lesson px-12 md-down:px-4 pb-10">
		<div
			class="__report-lesson__header py-10 flex flex-nowrap justify-between items-center md-down:flex-col md-down:gap-4 md-down:items-start"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl"
			>
				<svg
					width="28"
					height="28"
					viewBox="0 0 28 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M7 0.875C7 0.391751 6.60825 0 6.125 0C5.64175 0 5.25 0.391751 5.25 0.875V1.75H3.5C1.567 1.75 0 3.317 0 5.25V7H28V5.25C28 3.317 26.433 1.75 24.5 1.75H22.75V0.875C22.75 0.391751 22.3582 0 21.875 0C21.3918 0 21 0.391751 21 0.875V1.75H7V0.875ZM28 24.5V8.75H0V24.5C0 26.433 1.567 28 3.5 28H24.5C26.433 28 28 26.433 28 24.5ZM18.9937 15.4937C19.3354 15.152 19.3354 14.598 18.9937 14.2563C18.652 13.9146 18.098 13.9146 17.7563 14.2563L13.125 18.8876L11.1187 16.8813C10.777 16.5396 10.223 16.5396 9.88128 16.8813C9.53957 17.223 9.53957 17.777 9.88128 18.1187L12.5063 20.7437C12.6704 20.9078 12.8929 21 13.125 21C13.3571 21 13.5796 20.9078 13.7437 20.7437L18.9937 15.4937Z"
						fill="#94A3B8"
					/>
				</svg>
				<span class="ml-4">{{ scheduleTitle }}</span>
			</div>
			<div class="search-input" style="width: 350px">
				<div class="input-group input--lg">
					<input
						v-model="searchQuery"
						class="bg-white input-with-icon"
						placeholder="Gõ tên học sinh để bắt đầu tìm kiếm"
						type="text"
						@keyup="searching"
					/>
					<div class="input-icon absolute top-1/2">
						<DaIcon
							class="h-4 w-4 text-neutral-400"
							name="das--search"
						/>
					</div>
				</div>
			</div>
		</div>
		<ScheduleSectionNav />
		<ScheduleStatsGroup
			v-if="isGroupSchedule"
			:search-query="searchQuery"
		/>
		<div v-if="!isGroupSchedule && visibleTabs.length > 1" class="my-10">
			<div class="border-b border-neutral-200">
				<nav aria-label="Tabs" class="flex space-x-8 tabs">
					<div
						v-for="tab in visibleTabs"
						:key="tab.id"
						:class="
							activeTab === tab.id
								? 'text-yellow-700 border-yellow-500'
								: ''
						"
						@click="activeTab = tab.id"
						class="border-transparent hover:text-yellow-700 hover:border-yellow-500 text-neutral-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"
					>
						<div>{{ tab.name }}</div>
					</div>
				</nav>
			</div>
		</div>
		<div v-if="!isGroupSchedule && activeTab === 1">
			<div v-if="!isLoading" class="__report-lesson__container">
				<div v-for="data in statsData" :key="data" class="mb-10">
					<div class="flex items-center justify-between mb-3">
						<div
							class="text-neutral-600 font-bold text-lg"
							v-if="data.date"
						>
							Tháng {{ toMMYY(data.date) }}
						</div>
						<div
							class="flex items-center gap-1 cursor-pointer"
							@click="data.unhide = !data.unhide"
						>
							<svg
								v-if="data.unhide"
								width="12"
								height="6"
								viewBox="0 0 12 6"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M11 5.5L6 0.5L1 5.5"
									stroke="#E5A42B"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
							<svg
								v-else
								width="12"
								height="6"
								viewBox="0 0 12 6"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M1 0.5L6 5.5L11 0.5"
									stroke="#E5A42B"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>

							<div style="color: #e5a42b">
								{{ data.unhide ? 'Thu gọn' : 'Mở rộng' }}
							</div>
						</div>
					</div>
					<div
						class="grid gap-8 mb-10 md-down:gap-4 grid-cols-2 md-down:grid-cols-1"
					>
						<div
							class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
						>
							<div class="flex items-center flex-nowrap">
								<svg
									width="20"
									height="20"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clip-path="url(#clip0_11104_7921)">
										<path
											d="M7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75ZM13 9.75C12.31 9.75 11.75 10.31 11.75 11C11.75 11.69 12.31 12.25 13 12.25C13.69 12.25 14.25 11.69 14.25 11C14.25 10.31 13.69 9.75 13 9.75ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 9.71 2.02 9.42 2.05 9.14C4.41 8.09 6.28 6.16 7.26 3.77C9.07 6.33 12.05 8 15.42 8C16.2 8 16.95 7.91 17.67 7.74C17.88 8.45 18 9.21 18 10C18 14.41 14.41 18 10 18Z"
											fill="#94A3B8"
										/>
										<path
											d="M8 13.9895C8 13.9895 9.86667 18.4895 12 13.9895H8Z"
											fill="#94A3B8"
										/>
									</g>
									<defs>
										<clipPath id="clip0_11104_7921">
											<rect
												width="20"
												height="20"
												fill="white"
											/>
										</clipPath>
									</defs>
								</svg>

								<div class="text-neutral-500 text-sm ml-2">
									Học sinh
								</div>
							</div>
							<div
								class="flex items-center flex-nowrap justify-between"
							>
								<div
									class="text-neutral-600 font-bold text-4xl text-right"
								>
									{{ data.stats.student_count }} /
									{{ data.stats.total_student }}
								</div>
							</div>
						</div>
						<div
							class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
						>
							<div class="flex items-center flex-nowrap">
								<svg
									width="20"
									height="20"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 4.375C10 4.02982 9.72018 3.75 9.375 3.75C9.02982 3.75 8.75 4.02982 8.75 4.375V11.25C8.75 11.4743 8.87018 11.6814 9.06491 11.7927L13.4399 14.2927C13.7396 14.4639 14.1214 14.3598 14.2927 14.0601C14.4639 13.7604 14.3598 13.3786 14.0601 13.2073L10 10.8873V4.375Z"
										fill="#94A3B8"
									/>
								</svg>

								<div class="text-neutral-500 text-sm ml-2">
									Giờ can thiệp/ dự kiến
								</div>
							</div>
							<div
								class="flex items-center flex-nowrap justify-tbetween"
							>
								<div
									class="text-neutral-600 font-bold text-4xl text-right"
								>
									{{ data.stats.total_non_cancelled_hours }} /
									{{ data.stats.total_hours }}
								</div>
							</div>
						</div>
					</div>
					<div
						class="shadow-sm sm:rounded-2xl overflow-hidden"
						v-if="data.unhide"
					>
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												scope="col"
												class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
											>
												STT
											</th>
											<th
												scope="col"
												class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
											>
												HỌC SINH
											</th>
											<th
												scope="col"
												class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
												v-if="$route.query.type !== 'daycare'"
											>
												Giờ học can thiệp (thực tế / dự
												kiến)
											</th>
											<th
												scope="col"
												class="px-3 py-3 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-center"
												v-if="$route.query.type === 'daycare'"
											>
												Ngày học bán trú (thực tế / dự
												kiến)
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											@click="
												$router.push(
													`/schedule/stats/student?student_id=${
														item.student_id
													}&date=${dateSubmit(
														data.date
													)}`
												)
											"
											v-for="(
												item, i
											) in data.students_with_stats"
											:key="i"
											:class="
												i % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="text-neutral-700 cursor-pointer hover:bg-orange-50"
										>
											<td>
												<div
													class="px-3 py-4 text-center text-neutral-700"
												>
													{{ i + 1 }}
												</div>
											</td>
											<td
												class="px-3 py-4 whitespace-nowrap text-neutral-700"
											>
												<div
													class="flex items-center cursor-pointer"
												>
													<img
														class="shadow-sm inline-block h-6 w-6 rounded-full"
														:src="
															data.students_map[
																item?.student_id
															]?.profile_photo
																?.w200
														"
														v-if="
															data.students_map[
																item?.student_id
															]?.profile_photo
																?.w200
														"
														alt=""
													/>
													<span
														v-else
														class="inline-flex items-center justify-center h-6 w-6 rounded-full"
														:style="{
															background:
																data
																	.students_map[
																	item
																		?.student_id
																]
																	?.profile_photo
																	?.default
																	?.color,
														}"
													>
														<span
															class="text-xs font-medium leading-none text-white"
															>{{
																data
																	.students_map[
																	item
																		?.student_id
																]
																	?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
													<div
														class="ml-4 font-semibold text-orange-600 truncate"
													>
														{{
															data.students_map[
																item?.student_id
															]?.name
														}}
													</div>
												</div>
											</td>
											<td
												class="px-3 py-4 whitespace-nowrap text-neutral-700 text-center"
												v-if="$route.query.type !== 'daycare'"
											>
												{{
													item.total_non_cancelled_hours
												}}
												/
												{{ item.total_hours }}
											</td>
											<td
												class="px-3 py-4 whitespace-nowrap text-neutral-700 text-center"
												v-if="$route.query.type === 'daycare'"
											>
												{{
													item.total_day_care_learned
												}}
												/
												{{ item.total_day_care }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<DaInfinityLoading
					@infinite-load="getScheduleStats"
					:loaded="stopLoad"
					:is-loading="isFetching"
					v-if="isInfinityLoading"
				/>
			</div>
			<div v-else class="fixed top-1/2 left-1/2">
				<Loading />
			</div>
		</div>
		<div v-if="!isGroupSchedule && activeTab === 2">
			<div
				class="flex items-end justify-between gap-8 flex-wrap md-down:flex-col md-down:items-start"
			>
				<div class="flex items-end gap-8 flex-wrap">
					<div class="w-56">
						<div
							class="font-semibold uppercase text-gray-400 text-xs"
						>
							Từ ngày
						</div>
						<div class="w-full mt-2">
							<div class="input-group flex items-center">
								<VueDatepicker
									uid="personal-intervention-from-date"
									v-model="personalFromDate"
									:enableTimePicker="false"
									class="input-date w-full"
									placeholder="Chọn ngày bắt đầu"
									format="dd/MM/yyyy"
									autoApply
									:disabled="!enableReportBySession"
								>
									<template #input-icon>
										<DaIcon
											name="das--lock"
											class="h-4 w-4 text-neutral-400"
										/>
									</template>
								</VueDatepicker>
							</div>
						</div>
					</div>
					<div class="w-56">
						<div
							class="font-semibold uppercase text-gray-400 text-xs"
						>
							Tới ngày
						</div>
						<div class="w-full mt-2">
							<div class="input-group flex items-center">
								<VueDatepicker
									uid="personal-intervention-to-date"
									v-model="personalToDate"
									:enableTimePicker="false"
									class="input-date w-full"
									placeholder="Chọn ngày kết thúc"
									format="dd/MM/yyyy"
									autoApply
									:disabled="!enableReportBySession"
								>
									<template #input-icon>
										<DaIcon
											name="das--lock"
											class="h-4 w-4 text-neutral-400"
										/>
									</template>
								</VueDatepicker>
							</div>
						</div>
					</div>
					<div>
						<div
							class="font-semibold uppercase text-gray-400 text-xs"
						>
							{{ $filters.terminology('teacher') }}
						</div>
						<div class="mt-2 w-full md:w-48">
							<Multiselect
								v-model="personalStaffSelected"
								deselect-label="Đã chọn"
								track-by="id"
								:options="personalStaffOptions"
								:searchable="true"
								label="nameSearch"
								:allow-empty="true"
								selectLabel=""
								:placeholder="`Chọn ${$filters.terminology(
									'teacher'
								)}`"
								@update:modelValue="onPersonalStaffChange"
								:disabled="!enableReportBySession"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
								<template v-slot:option="props">
									<div class="flex flex-nowrap items-center">
										<div>{{ props.option.name }}</div>
									</div>
								</template>
								<template v-slot:singleLabel="{ option }">
									<div
										class="flex flex-nowrap items-center font-medium"
									>
										<div>{{ option.name }}</div>
									</div>
								</template>
							</Multiselect>
						</div>
					</div>
					<div class="pb-2 font-semibold text-gray-400 text-sm">
						Hoặc
					</div>
					<div>
						<div
							class="font-semibold uppercase text-gray-400 text-xs"
						>
							Học sinh
						</div>
						<div class="mt-2 w-full md:w-48">
							<Multiselect
								v-model="personalStudentSelected"
								deselect-label="Đã chọn"
								track-by="id"
								:options="personalStudentOptions"
								:searchable="true"
								label="nameSearch"
								:allow-empty="true"
								selectLabel=""
								placeholder="Chọn học sinh"
								@update:modelValue="onPersonalStudentChange"
								:disabled="!enableReportBySession"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
								<template v-slot:option="props">
									<div class="flex flex-nowrap items-center">
										<div>{{ props.option.name }}</div>
									</div>
								</template>
								<template v-slot:singleLabel="{ option }">
									<div
										class="flex flex-nowrap items-center font-medium"
									>
										<div>{{ option.name }}</div>
									</div>
								</template>
							</Multiselect>
						</div>
					</div>
				</div>
				<div
					class="flex items-end pb-2 cursor-pointer font-semibold text-gray-400 hover:text-gray-600 whitespace-nowrap"
					@click="removePersonalFilter"
				>
					Bỏ bộ lọc
				</div>
			</div>
			<div v-if="!personalIsLoading" class="mt-10">
				<div
					v-if="lessonStats.length"
					class="shadow-sm sm:rounded-2xl overflow-hidden"
				>
					<div class="__record__table overflow-x-auto scroll-bar">
						<div
							class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
						>
							<table class="min-w-full divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											scope="col"
											class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
										>
											STT
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											Tên hiển thị
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											Giờ đã dạy/ giờ dự kiến
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											Giờ dạy phát sinh
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											Giờ nghỉ dạy
										</th>
										<th
											scope="col"
											class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
										>
											Giờ chưa dạy
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, i) in lessonStats"
										:key="i"
										:class="
											i % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
										class="text-neutral-700"
									>
										<td>
											<div
												class="px-3 py-4 text-center text-neutral-700"
											>
												{{ i + 1 }}
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700"
										>
											<div class="flex items-center">
												<div>
													<img
														class="shadow-sm inline-block h-6 w-6 rounded-full"
														:src="
															item?.person_info
																?.profile_photo
																?.w200
														"
														alt=""
														v-if="
															item?.person_info
																?.profile_photo
																?.w200
														"
													/>
													<span
														v-else
														class="inline-flex items-center justify-center h-6 w-6 rounded-full"
														:style="{
															background:
																item
																	?.person_info
																	?.profile_photo
																	?.default
																	?.color,
														}"
													>
														<span
															class="font-medium leading-none text-white text-xs"
															>{{
																item
																	?.person_info
																	?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
												</div>
												<div
													class="ml-2 text-orange-600 font-semibold truncate"
												>
													{{
														item?.person_info?.name
													}}
												</div>
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 text-center"
										>
											{{ item.total_non_cancelled_hours }}
											/ {{ item.total_hours }}
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 text-center"
										>
											{{ item.total_unscheduled_hours }}
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 text-center"
										>
											{{ item.total_cancelled_hours }}
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 text-center"
										>
											{{ item.total_incompleted_hours }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div
					v-else
					class="w-full h-full mt-20 flex items-center justify-center flex-col"
				>
					<img
						src="@/assets/images/illustrations/not_found.png"
						alt=""
						height="250"
						width="250"
					/>
					<div
						class="text-neutral-500 text-lg text-center"
						style="max-width: 700px"
					>
						<div v-if="enableReportBySession">
							Không có dữ liệu thống kê
						</div>
						<div v-else>
							<div>Chưa có dữ liệu thống kê</div>
							<div>
								Thiết lập lịch học cho trung tâm để bắt đầu theo
								dõi thống kê giờ can thiệp cá nhân
							</div>
							<button
								@click="$router.push('/setup-center/schedule')"
								class="button-p btn--ghost text-center whitespace-nowrap w-fit px-6 m-auto mt-4"
							>
								Thiết lập lịch học
							</button>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="fixed top-1/2 left-1/2">
				<Loading />
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import DaInfinityLoading from '@/components/common/daInfinityLoading/DaInfinityLoading';
import { $api } from '@/services';
import Loading from '@/components/common/Loading';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import { toEnglish } from '@/helper/toEnglish';
import { flattenMap } from '@/helper/flattenMap';
import ScheduleSectionNav from '@/components/modules/schedule/ScheduleSectionNav.vue';
import ScheduleStatsGroup from '@/views/scheduleStats/features/ScheduleStatsGroup.vue';
import {
	scheduleKindFromRoute,
	scheduleSectionTitle,
} from '@/helper/scheduleSection';

export default {
	name: 'ScheduleStats',

	components: {
		Loading,
		DaInfinityLoading,
		DaIcon,
		Multiselect,
		ScheduleSectionNav,
		ScheduleStatsGroup,
	},

	data() {
		return {
			stopLoad: false,
			isInfinityLoading: false,
			date: dayjs().toDate(),
			statsData: [],
			isLoading: true,
			isFetching: false,
			requestSeq: 0,
			searchQuery: '',
			timeOut: null,
			tabs: [
				{
					id: 1,
					name: 'Lịch học',
				},
				{
					id: 2,
					name: 'Giờ can thiệp cá nhân',
				},
			],
			activeTab: 1,
			personalFromDate: null,
			personalToDate: null,
			personalStaffSelected: null,
			personalStudentSelected: null,
			personalStaffs: [],
			personalStudents: [],
			personalIsLoading: false,
			personalFilterTimeOut: null,
			lessonStats: [],
		};
	},

	computed: {
		scheduleTitle() {
			return scheduleSectionTitle(this.$route);
		},

		isGroupSchedule() {
			return scheduleKindFromRoute(this.$route) === 'group';
		},

		visibleTabs() {
			if (this.isGroupSchedule) return [];
			if (scheduleKindFromRoute(this.$route) === 'daycare') {
				return this.tabs.filter((tab) => tab.id !== 2);
			}
			return this.tabs;
		},

		personalStaffOptions() {
			return this.personalStaffs.map((staff) => ({
				nameSearch: toEnglish(staff?.name),
				...staff,
			}));
		},

		personalStudentOptions() {
			return this.personalStudents.map((student) => ({
				nameSearch: toEnglish(student?.name),
				...student,
			}));
		},
		enableReportBySession() {
			return this.$store.state.profile.current_org
				.enable_report_by_session;
		},
	},

	watch: {
		activeTab(value) {
			if (value === 2) {
				if (this.enableReportBySession) {
					this.initPersonalInterventionTab();
				}
			}
		},

		'$route.query.type'() {
			if (this.isGroupSchedule) return;
			if (
				scheduleKindFromRoute(this.$route) === 'daycare' &&
				this.activeTab === 2
			) {
				this.activeTab = 1;
			}
			if (!this.statsData.length) {
				this.isLoading = true;
				this.resetScheduleStats();
				this.getScheduleStats();
			}
		},

		personalFromDate() {
			this.schedulePersonalFilterChange();
		},

		personalToDate() {
			this.schedulePersonalFilterChange();
		},
	},

	created() {
		if (!this.isGroupSchedule) {
			this.getScheduleStats();
		}
	},

	methods: {
		dateSubmit(date) {
			return dayjs(date).format('YYYY-MM-DD');
		},
		toMMYY(date) {
			return dayjs(date).format('MM/YYYY');
		},
		prevMonth() {
			this.date = dayjs(this.date).subtract(1, 'month').toDate();
		},
		resetScheduleStats() {
			this.statsData = [];
			this.date = dayjs().toDate();
			this.stopLoad = false;
			// remount DaInfinityLoading, it drops its listeners once loaded
			this.isInfinityLoading = false;
			// let the next fetch through, the in-flight one is discarded
			this.isFetching = false;
			this.requestSeq++;
		},
		async getScheduleStats() {
			// the infinite loader re-emits while a month is still loading
			if (this.stopLoad || this.isFetching) return;
			this.isFetching = true;
			const requestId = ++this.requestSeq;
			try {
				const payload = {
					date: dayjs(this.date).format('YYYY-MM') + '-01',
				};
				if (this.searchQuery) {
					payload.name = this.searchQuery;
				}
				const { data } = await $api.schedule.scheduleStatsByMonth(
					payload
				);
				if (requestId !== this.requestSeq) return;
				if (data) {
					this.statsData.push({
						...data,
						students_map: flattenMap(data.students_map),
						date: this.date,
						unhide: true,
					});
					this.prevMonth();
				} else {
					this.stopLoad = true;
				}
			} catch (e) {
				console.log(e);
			} finally {
				if (requestId === this.requestSeq) {
					this.isLoading = false;
					this.isFetching = false;
					this.isInfinityLoading = true;
				}
			}
		},
		searching() {
			if (this.isGroupSchedule) return;
			clearTimeout(this.timeOut);
			this.timeOut = setTimeout(() => {
				this.resetScheduleStats();
				this.getScheduleStats();
			}, 300);
		},

		buildLessonStatsPayload() {
			const payload = {
				start_date: this.dateSubmit(this.personalFromDate),
				end_date: this.dateSubmit(this.personalToDate),
			};

			if (this.personalStaffSelected?.id) {
				payload.staff_id = this.personalStaffSelected.id;
			}

			if (this.personalStudentSelected?.id) {
				payload.student_id = this.personalStudentSelected.id;
			}

			return payload;
		},

		canFetchLessonStats() {
			return (
				this.personalFromDate &&
				this.personalToDate &&
				(this.personalStaffSelected?.id ||
					this.personalStudentSelected?.id)
			);
		},

		async initPersonalInterventionTab() {
			await Promise.all([
				this.fetchPersonalStaffs(),
				this.fetchPersonalStudents(),
			]);
		},

		schedulePersonalFilterChange() {
			if (this.activeTab !== 2) return;
			clearTimeout(this.personalFilterTimeOut);
			this.personalFilterTimeOut = setTimeout(() => {
				this.getLessonStats();
			}, 300);
		},

		onPersonalStaffChange(value) {
			if (value?.id) {
				this.personalStudentSelected = null;
			}
			this.schedulePersonalFilterChange();
		},

		onPersonalStudentChange(value) {
			if (value?.id) {
				this.personalStaffSelected = null;
			}
			this.schedulePersonalFilterChange();
		},

		removePersonalFilter() {
			if (!this.enableReportBySession) return;
			this.personalFromDate = null;
			this.personalToDate = null;
			this.personalStaffSelected = null;
			this.personalStudentSelected = null;
			this.clearPersonalInterventionStats();
			this.lessonStats = [];
		},

		async fetchPersonalStaffs() {
			try {
				const res = await $api.staff.getSimpleStaffs();
				this.personalStaffs = res?.data?.data || [];
			} catch (err) {
				console.log(err);
			}
		},

		async fetchPersonalStudents() {
			const isTeacher =
				this.$store.state.profile.staff.role === 'teacher';
			try {
				const res = isTeacher
					? await $api.student.getSimpleStudents()
					: await $api.student.getOrgSimpleStudents();
				this.personalStudents = res?.data?.data || [];
			} catch (err) {
				console.log(err);
			}
		},

		async getLessonStats() {
			if (!this.canFetchLessonStats()) {
				this.clearPersonalInterventionStats();
				return;
			}
			this.personalIsLoading = true;
			try {
				const { data } = await $api.org.getLessonStats(
					this.buildLessonStatsPayload()
				);

				this.lessonStats = data.data;
			} catch (e) {
				this.lessonStats = [];
			} finally {
				this.personalIsLoading = false;
			}
		},

		async downloadPersonalInterventionCSV() {
			try {
				const { data } =
					await $api.schedule.schedulePersonalInterventionExportToken(
						{
							from_date: this.dateSubmit(this.personalFromDate),
							to_date: this.dateSubmit(this.personalToDate),
							...(this.personalStaffSelected?.id
								? { staff_id: this.personalStaffSelected.id }
								: {}),
							...(this.personalStudentSelected?.id
								? {
										student_id:
											this.personalStudentSelected.id,
								  }
								: {}),
						}
					);

				window.location.href =
					process.env.VUE_APP_URL +
					`csv/personal_intervention_stats?secure_token=${data.token}`;
			} catch (e) {
				await this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
	},
};
</script>
